export default "__VITE_ASSET__CHL34jk4__"